import axios, { AxiosRequestConfig } from 'axios';

import { getClient, RESTClient, RESTClientMock } from '@api/client';
import { API_URL } from '@api/apiDictionary';
import { USE_API_MOCKS } from 'src/env';
import { replacePathParams } from 'src/utils/replacePathWithParams';
import { MeasurementReqParams } from '@dynamika-shared/types/measurements';
import {
  confirmScreenshotMeasurementMock,
  getScreenshotMeasurementMock,
} from './mocks/readerMeasurements';
import { uploadStatusCodeMock } from './mocks/uploadStatusCode';

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;
export enum ScreenshotStatuses {
  'CREATED' = 'CREATED',
  'COMPLETED' = 'COMPLETED',
}

export type GetScreenshotTypes = {
  id: string;
  measurementId: string;
  uploadSignUrl: string | null;
  downloadScreenshotUrl: string | null;
  downloadScreenshotThumbnailUrl: string | null;
  status: ScreenshotStatuses;
};

interface UploadOptions extends AxiosRequestConfig {
  signal?: AbortSignal;
}

export const getReaderScreenshot = async (
  clinicalTrialId: string,
  taskId: string,
  measurementId: string
) => {
  await getScreenshotMeasurementMock(taskId, clinicalTrialId);

  return api.get<GetScreenshotTypes>(
    replacePathParams(API_URL.readerTaskMeasurementGetScreenshot, {
      taskId,
      measurementId,
    }),
    {
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
    }
  );
};

export const setUploadScreenshot = async (
  file: Blob,
  signedUrl: string,
  contentType?: string,
  options: UploadOptions = {}
) => {
  if (USE_API_MOCKS) {
    return uploadStatusCodeMock();
  }
  //no response
  const response = await axios.request({
    method: 'PUT',
    url: signedUrl,
    data: file,
    headers: {
      'Content-Type': contentType ?? 'image/png',
    },
    ...options,
  });

  return { code: response.status };
};

export const setReaderScreenshot = async (
  measurementId: string,
  taskId: string,
  clinicalTrialId: string
) => {
  await confirmScreenshotMeasurementMock(taskId, measurementId);
  return getClient(API_URL.readerTaskMeasurementScreenshot).post<
    GetScreenshotTypes,
    MeasurementReqParams
  >(
    replacePathParams(API_URL.readerTaskMeasurementScreenshot, {
      taskId,
      measurementId,
    }),
    undefined,
    {
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
    }
  );
};
